// @flow
import React from 'react';
import type { EventPreviewType } from 'types/Event';
import { getMonthName } from 'utils/dateUtils';
import { Link } from 'react-router-dom';
import { handleTagEvent } from 'utils/tagManagerUtils';

type Props = {
  event: EventPreviewType
};

function getLink(event: EventPreviewType) {
  const { title } = event;

  if (event.redirection) {
    return (
      <a
        href={event.redirection}
        target="_blank"
        title={`Voir le détail de l'événement ${title}`}
        rel="noopener noreferrer"
        role="button"
        tabIndex={0}
        onClick={handleTagEvent('module evenement', `clic ${title}`, window.location.pathname)}
      >
        {event.title}
      </a>
    );
  }

  return (
    <Link
      to={{
        pathname: `/evenements/${event.slug}`
      }}
      role="button"
      tabIndex={0}
      title={`Voir les détails de l'événement ${title}`}
      onClick={handleTagEvent('module evenement', `clic ${title}`, window.location.pathname)}
    >
      {title}
    </Link>
  );
}

const RowEvent = (props: Props) => {
  let { label, categories } = props.event;
  if (categories && categories.length > 0) {
    label = categories.reduce((acc, category) => acc + (acc ? ' - ' : '') + category.name, '');
  }
  const startDate = props.event.startDate instanceof Date ? props.event.startDate : new Date(props.event.startDate);

  return (
    <div className="event-row ">
      <p className="event__date">
        <span className="event__day ft-h2">{startDate.getDate()}</span>
        <br />
        <span className="event__month ft-h6 ft-up">{getMonthName(startDate.getMonth())}</span>
      </p>
      <div className="event__content">
        <p className="event__title ft-h4">{getLink(props.event)}</p>
        <p className="ft-h6">
          <span className="event__type ft-up">{label}</span>
        </p>
      </div>
    </div>
  );
};

export default RowEvent;
